import { render, staticRenderFns } from "./ContentsCategories.vue?vue&type=template&id=2e41a144&"
import script from "./ContentsCategories.vue?vue&type=script&lang=js&"
export * from "./ContentsCategories.vue?vue&type=script&lang=js&"
import style0 from "./ContentsCategories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports